import BaseService from './base.service';

export default class UserInvitesService {
    static ENDPOINT = '/invites';
    static POST_ENDPOINT = '/users/me/invites';
    
    static async getUserInvites() {
        const endpoint = `${this.ENDPOINT}/me/pending`;
        return BaseService.get(endpoint);
    }

    static async accceptInvite(inviteId) {
        const endpoint = `${this.POST_ENDPOINT}/${inviteId}/accept`;
        return BaseService.post(endpoint);
    }

    static async denyInvite(inviteId) {
        const endpoint = `${this.POST_ENDPOINT}/${inviteId}/deny`;
        return BaseService.post(endpoint);
    }
}
